<div class="layout-footer">
    <img src="assets/{{layoutService.config.colorScheme === 'light' ? 'logotipo' : 'logotipo'}}.png" alt="Logo" height="20" class="mr-2" style="border-radius:3px;"/>
    by
    <span class="font-medium ml-2">Zionn.ai(admin)</span>
</div>
